module.exports = __webpack_public_path__ + "static/img/intfour.1f3776c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/intfour.png
// module id = lrlx
// module chunks = 29